import axios from "axios";

import { refreshToken } from "../APIConfig/CtfConfig";
import { startTransition } from "react";
import axiosErrorHandler from "../ErrorHandler/axiosErrHandler";
import jwtDecode from "jwt-decode";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_PATH,
});

API.interceptors.request.use(
  function (config) {
    const currentPath = window.location?.pathname;
    const accessToken = localStorage.getItem("access_token");
    if (accessToken) {
      try {
        const decodedToken = jwtDecode(accessToken);
        const isExpired = decodedToken.exp * 1000 < Date.now();
        if (isExpired) {
          startTransition(() => {
            refreshToken(currentPath);
          });
        }
      } catch (_) {}
    }
    return config;
  },
  function (error) {
    axiosErrorHandler(error);
    return Promise.reject(error);
  }
);

API.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    const currentPath = window.location?.pathname;
    if (
      error?.response?.data?.exception ===
      "An error of type InvalidUser occurred: Expired Token."
    ) {
      startTransition(() => {
        refreshToken(currentPath);
      });
    }
    axiosErrorHandler(error);
    return Promise.reject(error);
  }
);

export default API;
